import { render, staticRenderFns } from "./setting-ap-master.vue?vue&type=template&id=1d6f0601&scoped=true"
import script from "./setting-ap-master.vue?vue&type=script&lang=js"
export * from "./setting-ap-master.vue?vue&type=script&lang=js"
import style0 from "./setting-ap-master.vue?vue&type=style&index=0&id=1d6f0601&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6f0601",
  null
  
)

export default component.exports